import "./PostEditHistory.scss"

import React, { useEffect, useState } from "react"
import { Post, PostEdit } from "@fider/models"
import { Modal, Button, Loader, Avatar, Moment, Markdown } from "@fider/components"
import { actions } from "@fider/services"
import { useFider } from "@fider/hooks"
import { i18n } from "@lingui/core"
import { Trans } from "@lingui/react/macro"

// Tùy biến KHCN: modal lịch sử chỉnh sửa bài. Mỗi mục là nội dung TRƯỚC khi lần sửa đó diễn ra,
// kèm ai sửa và thời điểm. Bản hiện tại luôn là nội dung đang hiển thị trên trang.

interface PostEditHistoryProps {
  post: Post
  isOpen: boolean
  onClose: () => void
}

export const PostEditHistory = (props: PostEditHistoryProps) => {
  const fider = useFider()
  const [loading, setLoading] = useState(true)
  const [edits, setEdits] = useState<PostEdit[]>([])

  useEffect(() => {
    if (!props.isOpen) {
      return
    }
    setLoading(true)
    actions.getPostEdits(props.post.number).then((r) => {
      setLoading(false)
      if (r.ok) {
        setEdits(r.data)
      }
    })
  }, [props.isOpen, props.post.number])

  return (
    <Modal.Window isOpen={props.isOpen} onClose={props.onClose} size="large" className="c-editlog">
      <Modal.Header>
        <span className="c-editlog__heading">
          <Trans id="khcn.edits.title">Edit history</Trans>
        </span>
      </Modal.Header>
      <Modal.Content>
        {loading && <Loader />}
        {!loading && edits.length === 0 && (
          <p className="c-editlog__empty">
            <Trans id="khcn.edits.empty">This post has not been edited yet.</Trans>
          </p>
        )}
        {!loading && edits.length > 0 && (
          <>
            {/* Bản hiện tại */}
            <div className="c-editlog__item c-editlog__item--current">
              <div className="c-editlog__meta">
                <span className="c-editlog__badge c-editlog__badge--current">
                  <Trans id="khcn.edits.current">Current version</Trans>
                </span>
              </div>
              <div className="c-editlog__title">{props.post.title}</div>
              <Markdown className="c-editlog__desc" text={props.post.description} style="full" />
            </div>

            {/* Các bản trước, mới nhất trước */}
            <ol className="c-editlog__list">
              {edits.map((edit) => (
                <li className="c-editlog__item" key={edit.id}>
                  <div className="c-editlog__meta">
                    <Avatar user={{ name: edit.editor.name, avatarURL: edit.editor.avatarURL }} size="small" />
                    <span className="c-editlog__by">{edit.editor.name}</span>
                    <span className="c-editlog__dot" aria-hidden="true" />
                    <span className="c-editlog__time">
                      <Moment locale={fider.currentLocale} date={edit.editedAt} />
                    </span>
                  </div>
                  <div className="c-editlog__title">{edit.title}</div>
                  <Markdown className="c-editlog__desc" text={edit.description} style="full" />
                </li>
              ))}
            </ol>
          </>
        )}
      </Modal.Content>
      <Modal.Footer>
        <Button variant="tertiary" onClick={props.onClose}>
          {i18n._({ id: "action.close", message: "Close" })}
        </Button>
      </Modal.Footer>
    </Modal.Window>
  )
}
